// ImpressumPage.tsx — NEKO-hosted Impressum fallback page (LEGAL-01)
// Displayed when tenant has no custom impressum URL configured.
// Tenant-specific impressum should be configured via x-tenant-impressum-url meta tag.

import { Zap } from "lucide-react";

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-neko-dark flex flex-col">
      <header className="bg-neko-dark-2 border-b border-neko-dark-3">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-3">
          <a href="/" className="flex items-center gap-3 group cursor-pointer">
            <div className="w-10 h-10 bg-neko-orange rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-neko-orange/90 transition-colors">
              <Zap className="w-6 h-6 text-neko-dark" strokeWidth={2.5} />
            </div>
            <div>
              <span className="text-neko-white font-bold text-xl">NEKO</span>
              <span className="text-neko-gray text-sm ml-2">Bad · Wärme · Strom</span>
            </div>
          </a>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-8 flex-1 w-full animate-fade-in">
        <h1 className="text-neko-white font-bold text-2xl mb-6">Impressum</h1>
        <div className="text-neko-gray text-sm space-y-4 leading-relaxed">
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              Angaben gemäß § 5 TMG
            </h2>
            <p>
              NEKO Energie GmbH<br />
              Musterstraße 1<br />
              12345 Berlin<br />
              Deutschland
            </p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">Kontakt</h2>
            <p>E-Mail: info@neko-bws.de</p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              Handelsregistereintrag
            </h2>
            <p>Registergericht: Amtsgericht Berlin<br />
            Registernummer: HRB 000000</p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              Verantwortlich für den Inhalt gemäß § 55 Abs. 2 RStV
            </h2>
            <p>
              Geschäftsführung NEKO Energie GmbH<br />
              Musterstraße 1, 12345 Berlin
            </p>
          </section>
          <section>
            <p className="text-xs text-neko-gray/60">
              Hinweis: Diese Seite zeigt das Standard-Impressum von NEKO Energie.
              Partner-spezifische Impressum-Seiten werden über die Tenant-Konfiguration verlinkt.
            </p>
          </section>
        </div>
        <div className="mt-8">
          <a
            href="/"
            className="text-sm text-neko-gray hover:text-neko-white transition-colors"
          >
            ← Zurück zur Startseite
          </a>
        </div>
      </main>
    </div>
  );
}
